exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filters-panel{min-height:300px}.base-panel-footer .base-button{-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:200px;padding-top:5px;padding-bottom:5px}", ""]);
